import React from 'react';
import Styles from './ApartmentRedirect.css';
import { Timeout } from '../../widgets/Timeout/Timeout';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';

function ApartmentRedirect() {
  const { simulationStep, setSimulationStep, setResidencyType } = useSimuladorEnergiaSolarState();

  if (!(simulationStep?.id === SIMULATION_STEPS.END_JOURNEY_APARTMENT.id)) return null;

  return (
    <>
      <Timeout
        enabled={simulationStep?.id === SIMULATION_STEPS.END_JOURNEY_APARTMENT.id}
        timeout={2000}
        onTimeout={() => {
          window.open('https://fitenergia.com.br/santander', '_blank');

          setSimulationStep(SIMULATION_STEPS.FORM_BASIC_INFO);
          setResidencyType(null);
        }}
      >
        <ContainerHome24 id="apartment-redirect">
          <div className="informative">
            <img className="informative-img" src="assets/rastreadores/loader.gif" alt="" />
            <b className="informative-title">Sua jornada solar começa agora!</b>
            <p className="informative-subtitle">Estamos te transferindo para nosso parceiro</p>
          </div>
        </ContainerHome24>
      </Timeout>
      <style jsx>{Styles}</style>
    </>
  );
}

export default ApartmentRedirect;
